import state from './moduleOrganisationState.js'
import mutations from './moduleOrganisationMutations.js'
import actions from './moduleOrganisationActions.js'
import getters from './moduleOrganisationGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
